import { FolkProjector } from '../folk-projector';
FolkProjector.define();
export { FolkProjector };
//# sourceMappingURL=folk-projector.js.map